export const LOAD = 'load';
export const DESTROY = 'destroy';
export const ERROR = 'error';
export const READY = 'ready';
export const STATE_CHANGE = 'stateChange';


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/youtube-player/events.js
 **/